import { Directive, HostBinding, Input } from '@angular/core';

@Directive({
  standalone: true,
  selector: '[dataTestid]',
})
export class DataTestidDirective {
  @HostBinding('attr.data-testid') @Input() dataTestid: string;
}
